import Vue from "vue";
import axios from "axios";
import Router from "@/router/index";
// import _ from 'lodash'
import utils from "../utils/myUtils";
import { Message } from "element-ui";
import qs from "qs";
import loading from "./loading";

// FIXME
// TODO 之后按作者的写法，将API抽出来，与vuex相结合
// TODO token失效后，还处于登录状态的处理
// 服务器本地
// const baseUrl = 'https://localhost/weavermes/'
// 华为云服务器
// const baseUrl = 'https://viiku.com/weavermes/'
// 新云服务器
const baseUrl = "https://fjhsny.cn/weavermes/";
// const baseUrl = "http://175.42.63.203/weavermes/";
// 华为云测试服务器
//const baseUrl = 'https://test.viiku.com/weavermes/'
// 本地苹果测试服务器
// const baseUrl = 'http://192.168.1.104:8888/weavermes/'
// const baseUrl = 'http://172.22.13.85:8888/weavermes/'
// 通过本地host访问，用在测试服务器上
// const baseUrl = 'http://21901q31i8.51vip.biz/weavermes/'
//const baseUrl = 'http://localhost:8888/weavermes/'
// hcy测试环境
// const baseUrl = 'http://192.168.1.116:8888/weavermes/'

const timeout = 120000;
function responseSuccess(response) {
  // developLog(response)
  if (!utils.isEmpty(response.data.status) && response.data.status !== 200) {
    Message.error(response.data.msg);
    return Promise.reject(new Error(response));
  }
  if (!utils.isEmpty(response.data.code) && response.data.code !== 200) {
    Message.error(response.data.msg);
    return Promise.reject(new Error(response));
  }
  // 因为删除操作，返回的data会为空，但是删除是成功的，所以暂时注掉下面这段代码
  // if (myUtils.isEmpty(response.data) || myUtils.isEmpty(response.data.data)) {
  //   Message.error('返回的数据为空！')
  //   return Promise.reject(new Error(response))
  // }
  return response.data;
}
// eslint-disable-next-line no-unused-vars
function developLog(response) {
  var requestParams = "";
  if (!utils.isEmpty(response.config.data)) {
    requestParams = JSON.stringify(response.config.data);
  } else if (!utils.isEmpty(response.config.params)) {
    requestParams = JSON.stringify(response.config.params);
  }
  if (utils.isEmpty(response.data) || utils.isEmpty(response.data.data)) {
    console.log(
      "requestUrl:",
      response.config.url,
      "\n",
      "requestParams:" + requestParams,
      "\n",
      response.data
    );
  } else {
    console.log(
      "requestUrl:",
      response.config.url,
      "\n",
      "requestParams:" + requestParams,
      "\n",
      response.data.data
    );
  }
}
function responseError(error) {
  const data = error.response.data;
  if (data.code === 401) {
    Router.push("/login");
  }
  if (!utils.isEmpty(data.data) || !utils.isEmpty(data.info)) {
    const data = error.response.data;
    Message.error(data.data ? `${data.info},${data.data}` : `${data.info}`);
  } else {
    Message.error("系统错误:请联系管理员！");
  }
  return Promise.reject(error);
}
function initRequest(config) {
  config.headers.Authorization = window.sessionStorage.getItem("token");
  if (config.headers["Content-Type"] === "application/x-www-form-urlencoded") {
    config.data = qs.stringify(config.data);
  } else if (config.headers["Content-Type"] === "application/json") {
    config.data = qs.stringify(config.data);
  }
  return config;
}
const axiosFactory = axios.create({
  baseURL: baseUrl + "factory/", // api的base_url
  timeout: timeout, // 请求超时时间,
  // params: { factoryId: window.sessionStorage.getItem('factoryId') }
});

axiosFactory.interceptors.request.use((config) => {
  return initRequest(config);
});

axiosFactory.interceptors.response.use(
  (response) => {
    return responseSuccess(response);
  },
  (error) => {
    return responseError(error);
  }
);

const axiosPlatform = axios.create({
  baseURL: baseUrl + "platform/",
  timeout: timeout, // 请求超时时间
});
axiosPlatform.interceptors.request.use((config) => {
  return initRequest(config);
});
axiosPlatform.interceptors.response.use(
  (response) => {
    return responseSuccess(response);
  },
  (error) => {
    return responseError(error);
  }
);

const axiosBase = axios.create({
  baseURL: baseUrl,
  timeout: timeout, // 请求超时时间
});
axiosBase.interceptors.request.use((config) => {
  return initRequest(config);
});
axiosBase.interceptors.response.use(
  (response) => {
    return responseSuccess(response);
  },
  (error) => {
    return responseError(error);
  }
);

function requestFactory(configParam, loadingTip = false) {
  loadingTip && loading.showLoading();
  return axiosFactory(configParam)
    .then(
      (res) => {
        return new Promise((resolve) => resolve(res));
      },
      (rej) => {
        return new Promise((resolve, reject) => reject(rej));
      }
    )
    .finally(() => {
      loadingTip && loading.hideLoading();
    });
}

function requestPlatform(configParam, loadingTip = false) {
  loadingTip && loading.showLoading();
  return axiosPlatform(configParam)
    .then(
      (res) => {
        return new Promise((resolve) => resolve(res));
      },
      (rej) => {
        return new Promise((resolve, reject) => reject(rej));
      }
    )
    .finally(() => {
      loadingTip && loading.hideLoading();
    });
}

function requestBase(configParam, loadingTip = true) { //hongmj: 加载中，统一使用转圈圈。
  loadingTip && loading.showLoading();
  return axiosBase(configParam)
    .then(
      (res) => {
        return new Promise((resolve) => resolve(res));
      },
      (rej) => {
        return new Promise((resolve, reject) => reject(rej));
      }
    )
    .finally(() => {
      loadingTip && loading.hideLoading();
    });
}

Plugin.install = function(Vue, options) {
  Vue.prototype.$request = requestFactory;
  Vue.prototype.$request2 = requestPlatform;
  Vue.prototype.$requestBase = requestBase;
  Vue.prototype.$axios = axios;
  // 微信二维码回调地址
  // Vue.prototype.$baseUrl = "https://hskjl.com/#";
  Vue.prototype.$baseUrl = "https://fjhsny.cn/#";
};

Vue.use(Plugin);

export default Plugin;

export { requestFactory, requestPlatform, requestBase, axios };
